export const APPS = [
  {
    id: "remedio",
    name: "Remedio",
    icon: "💊",
    tagline: "Care, organised.",
    status: "available",
    statusLabel: "Available",
    statusColor: "#1A9A60",
    accent: "#6D3FE0",
    platform: "Android",
    category: "Health & Wellness",
    developer: "Nismay Studios",
    desc: "Remedio is a simple and thoughtful medicine reminder app designed to help individuals and families manage daily medication schedules. With scheduled reminders, medicine photographs, offline support and family connectivity, everyday medication management becomes easier and more organised.",
    features: [
      { icon: "⏰", title: "Smart Medicine Reminders", desc: "Set medicine names, dosages, schedules and days. Get timely reminders with sound and vibration." },
      { icon: "📴", title: "Offline Access", desc: "Locally stored medicine info and scheduled reminders keep working without an internet connection." },
      { icon: "👨‍👩‍👧", title: "Family Connectivity", desc: "Connect family members and coordinate medicine schedules together. Private by default, shared only when you choose." },
      { icon: "☁️", title: "Cloud Synchronisation", desc: "Sync medicine information with your account and access it across supported devices." },
      { icon: "✨", title: "Simple & Accessible", desc: "A clean, straightforward interface made for users of every age group." },
    ],
    screenshots: [
      { src: "/assets/remedio/login.jpeg", label: "Sign in" },
      { src: "/assets/remedio/medicines.jpeg", label: "My medicines" },
      { src: "/assets/remedio/edit.jpeg", label: "Add reminders" },
      { src: "/assets/remedio/family.jpeg", label: "Family sharing" },
    ],
    cta: { label: "Get it on Android", href: "https://play.google.com/store/apps/details?id=YOUR_PACKAGE_ID" }, // TODO: replace
    disclaimer: "Remedio is a medication organisation and reminder tool. It does not provide medical advice, prescribe medicines or replace guidance from healthcare professionals.",
  },
  {
    id: "nismay-browser",
    name: "Nismay Browser",
    icon: "🧭",
    tagline: "A browser, built our way.",
    status: "dev",
    statusLabel: "In Development",
    statusColor: "#D4900A",
    accent: "#D4900A",
    platform: "Coming soon",
    category: "Browser",
    developer: "Nismay Studios",
    desc: "We're building our own browser. Details are still under wraps. Follow along or get in touch if you'd like to hear when it's ready.",
    features: [],
    screenshots: [],
    cta: {
      label: "Get notified",
      href: "mailto:info@nismaystudios.in?subject=Nismay%20Browser%20-%20Notify%20me&body=Hi%20Mayur%2C%0A%0APlease%20let%20me%20know%20when%20Nismay%20Browser%20is%20ready.%0A",
    },
  },
];